export default "__VITE_ASSET__7be8cd08__"